import React from 'react';
import { BRAND, faseKleur } from '../../styles/brand';

/** Fase-label boven de paginatitel, in de kleur van de stap in het compas. */
export const FaseTag: React.FC<{ nr: number }> = ({ nr }) => (
  <span style={{ display: 'flex', width: 'fit-content', alignItems: 'center', gap: 8, padding: '3px 12px 3px 3px', borderRadius: 999, background: faseKleur(nr).base, color: BRAND.groen, fontSize: 12.5, fontWeight: 700, marginBottom: 10 }}>
    <span style={{ width: 22, height: 22, borderRadius: '50%', background: BRAND.groen, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>{nr}</span>
    Fase {nr}
  </span>
);
